import { render } from "./TaskFolderItemList.vue?vue&type=template&id=7ab136ae"
import script from "./TaskFolderItemList.vue?vue&type=script&lang=js"
export * from "./TaskFolderItemList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__